import SideBar from "./SideBar";
import "../blocks/profile/profile.css";
import FavoritesSection from "./FavoritesSection";

const FavoritesPage = ({
  userName,
  userAvatar,
  favorites,
  onCreateFavorite,
  onDeleteFavorite,
  onEditProfile,
  onLogout,
}) => {
  return (
    <div className="profile__section">
      <SideBar
        userName={userName}
        userAvatar={userAvatar}
        onEditProfile={onEditProfile}
        onLogout={onLogout}
      />
      <FavoritesSection
        favorites={favorites}
        onCreateFavorite={onCreateFavorite}
        onDeleteFavorite={onDeleteFavorite}
      />
    </div>
  );
};

export default FavoritesPage;
